import UpdatePrivateEventScreen from "../Auth/Event/UpdatePrivateEventScreen";
import UpdatePublicEventScreen from "../Auth/Event/UpdatePublicEventScreen";
import HelpScreen from "../Auth/WebScreens/HelpScreen";
import TicketHistory from "../Auth/WebScreens/TicketHistory";

export const AppScreens = {
  SignupScreen: "SignupScreen",
  LoginScreen: "LoginScreen",
  AboutYouFirstScreen: "AboutYouFirstScreen",
  CodeVerificationScreen: "CodeVerificationScreen",
  CreateAvatarScreen: "CreateAvatarScreen",
  ChooseGameLikeScreen: "ChooseGameLikeScreen",
  ChooseAvatarScreen: "ChooseAvatarScreen",
  AboutYouSecondScreen: "AboutYouSecondScreen",
  AboutYouThirdScreen: "AboutYouThirdScreen",

  //web
  LoginWebScreen: "LoginWebScreen",
  HomeWebScreenStatic: "HomeWebScreenStatic",
  SetupScreen: "SetupScreen",
  SignupWebScreen: "SignupWebScreen",
  EmailConfirmationWebScreen: "EmailConfirmationWebScreen",
  ResetPasswordWebScreen: "ResetPasswordWebScreen",
  ResetSetPasswordWebScreen: "ResetSetPasswordWebScreen",
  HomeWebScreen: "HomeWebScreen",
  Home: "Home",
  HomeScreen: "HomeScreen",
  TicketDetailWebScreen: "TicketDetailWebScreen",
  SearchEventWebScreen: "SearchEventWebScreen",
  helpSearch: "helpSearch",
  DrawerRoute: "DrawerRoute",
  SettingWebScreen: "SettingWebScreen",
  StreamSetup: "StreamSetup",
  MyProfileWebScreen: "Profile",
  Profile: "Profile",
  ChangeAvatar: "ChangeAvatar",
  PurchaseScreen: "PurchaseScreen",
  Redeem: "Redeem",
  SearchGameWebScreen: "SearchGameWebScreen",
  RefundRequestScreen: "RefundRequestScreen",
  ProfileMain: "ProfileTabStack",
  PurchaseTabStack: "PurchaseTabStack",
  NotificationMain: "NotificationTabStack",
  NotificationScreen: "Notifications",
  PaymentDone: "PaymentDone",
  PaymentSuccess: "payment/success",
  PaymentFailed: "payment/failure", // Changed to match Viva's redirect URL
  PaymentCancel: "payment/cancel",
  ViewTrasactionHistory: "ViewTrasactionHistory",
  TicketHistory: "TicketHistory",
  UserProfile: "UserProfile",
  HelpScreen: "Help",
  HelpTabStack: "HelpTabStack",
  DisputeCenterTabStack: "DisputeCenterTabStack",
  DisputeCenter: "DisputeCenter",
  DisputeManagementScreen: "DisputeManagementScreen",
  DisputeDetailScreen: "DisputeDetailScreen",
  disputeCenter: "disputeCenter",
  ContactUsCenter: "ContactUsCenter",
  GameShowScreen: "GameShowScreen",
  GameShowPreviewScreen: "GameShowPreviewScreen",
  OnGoingEvents: "OnGoingEvents",
  OnGoingEventsStreamingSetup: "OnGoingEventsStreamingSetup",
  Chat: "Chat",
  AddFriends: "AddFriends",
  LiveStreaming: "LiveStreaming",
  PastEvent: "PastEvent",
  GoLive: "GoLive",
  SupportChat: "chat",
  //Event
  EventTypeScreen: "EventTypeScreen",
  CreatePrivateEventScreen: "CreatePrivateEventScreen",
  CreatePublicEventScreen: "CreatePublicEventScreen",
  UpdatePublicEventScreen: "UpdatePublicEventScreen",
  UpdatePrivateEventScreen: "UpdatePrivateEventScreen",
  EventSummary: "EventSummary",
  PrivateEventSummary: "PrivateEventSummary",
  MyEventsMain: "MyeventsTabStack",
  MyEventsScreen: "MyEventsScreen",
  SearchMobileScreen: "SearchMobileScreen",
  SettingMain: "SettingTabStack",
  CreateTicketEventScreen: "CreateTicketEventScreen",
  SoloStreaming: "SoloStreaming",
  StreamerGoLive: "StreamerGoLive",
};
